import { IFormattedMessage } from '../models/common/IFormattedMessage';
import { successToast } from './toastrHelper';

export const copyToClipboard = (value: string, message?: IFormattedMessage) => {
  const el = document.createElement('textarea');
  el.value = value;
  document.body.appendChild(el);
  el.select();
  document.execCommand('copy');
  document.body.removeChild(el);

  if (message) {
    successToast(message.defaultMessage, message.id);
  }
};
